export default __webpack_public_path__ + "static/media/4-temple.d5145674.png";